import { APP_STATUS } from "./constants"

import { DataTransfer } from "./services"

class ButtonsPanel {
  el:HTMLDivElement
  buttons: NodeListOf<Element>
  appStatus: string
  miniBasket: HTMLDivElement | null
  dataTransfer
  formData
  

  constructor(mountEl:HTMLDivElement) {
    this.el = mountEl
    this.buttons = mountEl.querySelectorAll('.js-buttons-item')
    this.miniBasket = document.querySelector('.mini-basket')

    this.appStatus = APP_STATUS.ready
    this.dataTransfer = new DataTransfer
    this.formData = new FormData()
  }

  public setup() {
    this.buttons.forEach((button:Element) => {
      button.addEventListener('click', (e:Event) => {
        e.preventDefault()
        const button:HTMLElement = e.target as HTMLElement
        const productId:string = button.dataset.productId || ''
        const buttonText:string = button.innerText

        this.formData.append(`quantity[${productId}]`, '1' )

        this.setButtonText(APP_STATUS.loading, e.target as HTMLElement)
        this.transferData().then((res:any) => {
          this.appStatus = APP_STATUS.done
          this.setButtonText(this.appStatus, e.target as HTMLElement)

          if(this.miniBasket)
            this.miniBasket.innerHTML = res || ''

          setTimeout(() => {
            this.appStatus = APP_STATUS.ready
            this.setButtonText(this.appStatus, e.target as HTMLElement, buttonText)
          }, 2000)
        })
      })
    })
  }

  private transferData = async () => {
    this.appStatus = APP_STATUS.loading
    const res = await this.dataTransfer.sendData(this.formData)
    
    return res
  }

  private setButtonText = (status:string, button:HTMLElement, text:string = 'Купить') => {
    const textMap = {
      ready: `${text}`,
      loading: `<span class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="sr-only">Добавляем...</span>
                </span>`,
      done: 'Добавлено'
    }

    button!.innerHTML = textMap[status as keyof typeof textMap]
  }
}

export default ButtonsPanel